/**
 * Meta Pixel conversion events. Requires base pixel in HTML (window.fbq).
 * Fires at most once per Firebase user id (localStorage) when premium is confirmed from Firestore.
 *
 * Standard events use Meta’s documented names and parameters:
 * https://developers.facebook.com/docs/meta-pixel/reference
 */

/** Lemon Squeezy variant id — keep in sync with `PRODUCT_ANNUAL` in auth-ui.js */
const CHECKOUT_CONTENT_ID = 'a11905f7-02da-4dc8-904a-9a3b45bd5182';

const STORAGE_PREFIX = 'meta_pixel_premium_conversion_';

function firedKey(uid) {
  return STORAGE_PREFIX + uid;
}

/**
 * @param {object} opts
 * @param {string} opts.uid - Firebase user uid
 * @param {boolean} [opts.lifetimeAccess] - true for one-time "Forever" purchase
 */
export function trackPremiumConversion({ uid, lifetimeAccess = false }) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function' || !uid) {
    return;
  }
  try {
    if (localStorage.getItem(firedKey(uid))) {
      return;
    }
    if (lifetimeAccess) {
      const params = { currency: 'USD' };
      const v = import.meta.env.VITE_META_PIXEL_LIFETIME_VALUE;
      if (v != null && v !== '' && !Number.isNaN(Number(v))) {
        params.value = Number(v);
      }
      window.fbq('track', 'Purchase', params);
    } else {
      window.fbq('track', 'Subscribe', { currency: 'USD' });
    }
    localStorage.setItem(firedKey(uid), '1');
  } catch (_) {
    /* localStorage blocked or other */
  }
}

function buildInitiateCheckoutParams() {
  const params = {
    content_ids: [CHECKOUT_CONTENT_ID],
    content_type: 'product',
    num_items: 1,
    currency: 'USD'
  };
  const v = import.meta.env.VITE_META_PIXEL_CHECKOUT_VALUE;
  if (v != null && v !== '' && !Number.isNaN(Number(v))) {
    params.value = Number(v);
  }
  return params;
}

/** Fires when user opens Lemon Squeezy checkout (funnel step before Subscribe/Purchase). */
export function trackInitiateCheckout() {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }
  try {
    window.fbq('track', 'InitiateCheckout', buildInitiateCheckoutParams());
  } catch (_) {
    /* ignore */
  }
}

/**
 * Standard PageView for SPA “virtual” screens (e.g. journal). Initial load is already tracked in HTML via fbq('track', 'PageView').
 */
export function trackMetaPageView() {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }
  try {
    window.fbq('track', 'PageView');
  } catch (_) {
    /* ignore */
  }
}
